import React from 'react';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { ArrowForwardIosTwoTone } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { PageHeader } from '../Layout/styles';
import { removeAllAuthCookies } from '../../utils/authCookies';
const LOGIN_ENDPOINT = (window as any).REACT_APP_AUTH_URL || '/';
const ORGANIZER = (window as any).REACT_APP_ORGANIZER || 'buszrent';

const LoginPaper = () => {
    const handleLogin = () => {
        console.log('handleLogin');
        removeAllAuthCookies();
        window.location.assign(`${LOGIN_ENDPOINT}?r=${encodeURIComponent(window.location.href)}`);
    };
    return (
        <Box sx={{ m: 0, p: 0 }}>
            <PageHeader px={5}>
                <Link to='/'>
                    <img
                        src={`https://brspc.fra1.digitaloceanspaces.com/assets/img/${ORGANIZER}/logo-horizontal-white.png`}
                        alt={ORGANIZER === 'buszrent' ? 'BuszRent logo' : 'Human Transport Solution logo'}
                        style={{ maxWidth: 200 }}
                    />
                </Link>
            </PageHeader>
            <Grid container sx={{ minHeight: '80vh' }}>
                <Paper
                    sx={{
                        width: 'fitContent',
                        display: 'inline-block',
                        p: 3,
                        margin: 'auto',
                    }}>
                    <Typography variant={'h4'}>Kilépés</Typography>
                    <Typography paragraph>A munkamenet lejárt.</Typography>
                    <Button sx={{ mx: 1, borderRadius: 50 }} variant={'contained'} color={'primary'} onClick={handleLogin} endIcon={<ArrowForwardIosTwoTone />}>
                        Tovább a bejelentkezéshez{' '}
                    </Button>
                </Paper>
            </Grid>
        </Box>
    );
};

export { LoginPaper };
